import React, {useMemo} from "react";
import {Button, Modal, Table, Typography} from "antd";
import {ColumnsType} from "antd/es/table";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {InvoiceData} from "../../../../../../models/documents/invoices/invoice-data/invoice.data";
import {columnsFactory} from "./agent.data.invoices.new.created-invoices.modal.columns";

interface AgentDataInvoicesNewCreatedInvoicesModalProps {
    invoices: InvoiceData[];
    onClose: () => void;
}

export const AgentDataInvoicesNewCreatedInvoicesModal: React.FC<
    AgentDataInvoicesNewCreatedInvoicesModalProps
> = ({invoices, onClose}) => {
    const t = useTranslate();
    const columns: ColumnsType<InvoiceData> = useMemo(() => columnsFactory(t), [t]);

    return (
        <Modal
            open
            width={650}
            title={t("INVOICES.CREATE.MULTIPLE.TITLE", {defaultValue: "Sale documents created"})}
            onCancel={onClose}
            footer={(
                <Button type="primary" onClick={onClose}>
                    {t("CLOSE", {defaultValue: "Close"})}
                </Button>
            )}
        >
            <Typography.Paragraph>
                {t("INVOICES.CREATE.MULTIPLE.DESCRIPTION", {
                    defaultValue: "The selected orders were split into several sale documents.",
                })}
            </Typography.Paragraph>
            <Table<InvoiceData>
                rowKey="id"
                columns={columns}
                dataSource={invoices}
                pagination={false}
                size="small"
            />
        </Modal>
    );
};
